/**
 *
 * @module dustPayload
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../../exception/invalidArgumentException';

import DustServerPayload from './dustServerPayload';
import DustClientPayload from './dustClientPayload';

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class DustPayload
 * @implements {TelemetryPayload}
 * @since 3.4.0
 * @desc contains either client and/or server information for this event
 *
 */
export default class DustPayload {

    /**
     *
     * @access private
     * @param {SDK.Services.Internal.Dust.DustClientPayload} client
     * @param {SDK.Services.Internal.Dust.DustServerPayload} [server={}]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(client, server = {}) {

        const errorMessage = {
            ctor: 'DustPayload(client, server)',
            get client() {
                return `${this.ctor} needs a DustClientPayload instance`;
            },
            get server() {
                return `${this.ctor} needs a DustServerPayload instance`;
            }
        };

        instanceStrict(client, DustClientPayload, errorMessage.client, InvalidArgumentException);

        if (Check.nonEmptyObject(server)) {
            instanceStrict(server, DustServerPayload, errorMessage.server, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {Object}
         * @desc Dictionary containing server provided tracking information.
         *
         */
        this.server = server;

        /**
         *
         * @access public
         * @type {Object}
         * @desc Dictionary containing client provided tracking information.
         *
         */
        this.client = client;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/dust/dustPayload.js